/* unplugin-vue-components disabled */import { render } from "./evaluatedetail.vue?vue&type=template&id=17d74f6b&scoped=true"
import script from "./evaluatedetail.vue?vue&type=script&lang=js"
export * from "./evaluatedetail.vue?vue&type=script&lang=js"

import "./evaluatedetail.vue?vue&type=style&index=0&id=17d74f6b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d74f6b"]])

export default __exports__